import { render, staticRenderFns } from "./TodoFooter.vue?vue&type=template&id=4e398b74&"
import script from "./TodoFooter.vue?vue&type=script&lang=js&"
export * from "./TodoFooter.vue?vue&type=script&lang=js&"
import style0 from "./TodoFooter.vue?vue&type=style&index=0&id=4e398b74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports